













































































import loadImage from 'blueimp-load-image';
import { Component, Model, Prop } from 'vue-property-decorator';

import Dropzone from '@/componentsV2/molecules/Dropzone/Dropzone.vue';
import PaperClip from '@/components/icons/PaperClip.vue';
import ImageUploadIcon from '@/components/icons/ImageUploadIcon.vue';
import CloseCircleIcon from '@/components/icons/CloseCircle.vue';
import { HTMLInputEvent } from '@/components/TextArea/TextAreaModel';
import InputBase from '@/componentsV2/molecules/Inputs/InputBase.vue';
import InputWrapper from '@/componentsV2/molecules/Inputs/InputWrapper.vue';
import ModalOptions from '@/components/Modal/ModalOptions';
import Loading from '@/components/icons/Loading.vue';
import CloseCircle from '@/components/icons/CloseCircle.vue';

import eventBus from '@/utils/eventBus';
import { dataURItoBlob, getBase64FromUrl } from '@/utils/image';
import { isIos } from '@/utils/is-ios';

type ImageUploadBlockValue = {
  imageFile?: File | null;
  imageUrl: string;
};

const initialState = () => ({ imageFile: null, imageUrl: '' });

@Component({
  components: {
    InputWrapper,
    Dropzone,
    PaperClip,
    ImageUploadIcon,
    CloseCircleIcon,
    Loading,
    CloseCircle
  }
})
export default class ImageUploadBlock extends InputBase {
  @Prop({ default: false }) isOptional?: boolean;
  @Prop({ default: false }) brandedCoinShape?: boolean;
  @Prop({ default: false }) brandedCoinColor?: boolean;
  @Prop({ default: true }) showHelpIcon?: boolean;
  @Prop({ default: false }) loading?: boolean;
  @Prop({ default: false }) uploadFailed?: boolean;
  @Prop({ default: false }) disabled?: boolean;
  @Model('input', {
    type: Object,
    default: initialState
  })
  value!: ImageUploadBlockValue;
  cropMinZoom = 1;
  showPreview = false;
  initialCropState: any = null;
  imageId: string = '';
  nameFile: string = '';
  originalFile: string = '';
  previousOriginalFile: string = '';
  boundaryOptions = this.getSize();
  viewportOptions = {
    ...this.boundaryOptions,
    type: 'circle'
  };
  options = {
    type: 'blob',
    size: 'original',
    circle: false,
    quality: 0.85,
    format: 'jpeg'
  };

  get labelField() {
    return this.label || this.$t(`${this.tPrefix}.label`);
  }

  getSize() {
    let size = 352;

    if (window.innerHeight < 698 || window.innerWidth < 768) {
      size = 200;
    }

    return {
      width: size,
      height: size
    };
  }

  handleReset() {
    if (this.disabled) {
      return;
    }

    this.$emit('input', initialState());
  }

  onInput(event: HTMLInputEvent) {
    const files = event.target.files || [];

    this.handleDropzoneInput(Array.from(files));
  }

  get tPrefix() {
    return 'common.components.imageUploadBlock';
  }

  handleDropzoneInput(files: File[]) {
    const [file] = files;

    if (!file) return;

    this.$emit('selectedImage', file);

    const supportedFileTypes = ['jpeg', 'png', 'jpg', 'svg'];
    if (!supportedFileTypes.some(type => file.type.includes(type))) {
      this.$notification(
        String(this.$t(`${this.tPrefix}.warnFormatFile`)),
        'warn'
      );
      return;
    }

    const sizeInMB = file.size / 1024 / 1024;

    if (sizeInMB > 5) {
      this.$notification(
        String(this.$t(`${this.tPrefix}.warnMaximumFileSize5`)),
        'warn'
      );
      return;
    }

    this.$showLoaderWithLocker();
    this.initialCropState = null;
    this.nameFile = file.name;

    loadImage(
      file,
      async (canvas: HTMLCanvasElement) => {
        const link = canvas.toDataURL('image/png', 1);
        const image = new Image();
        image.onload = () => {
          const minDimesion = Math.min(image.width, image.height);
          this.cropMinZoom = this.boundaryOptions.width / minDimesion;

          this.originalFile = link;
          this.enterEditMode();

          this.$hideLoader();
        };
        image.src = link;
      },
      { canvas: true, meta: true, orientation: true }
    );
  }

  saveImage(actualFile: any) {
    this.previousOriginalFile = String(this.originalFile);
    const file = actualFile;
    const imageUrl = URL.createObjectURL(file);
    this.$emit('input', {
      imageFile: file,
      imageUrl,
      imageName: this.nameFile
    });
    this.onImageUpdate(imageUrl);
  }

  onImageUpdate(imageUrl: string) {
    eventBus.$emit('onImageUpdate', imageUrl);
  }

  resetInputFile() {
    const containerEl = this.$refs.imageUploadContainer as
      | HTMLElement
      | undefined;

    if (!containerEl) return;

    const inputFileEl = containerEl.querySelector<HTMLInputElement>(
      'input[type="file"]'
    );

    if (inputFileEl) {
      inputFileEl.value = '';
    }
  }

  saveEditMode({ img, cropState, original }: any) {
    this.initialCropState = cropState;
    const output = dataURItoBlob(img);

    this.showPreview = true;

    this.saveImage(output);
  }

  onCancelEditMode() {
    this.resetInputFile();
    this.originalFile = String(this.previousOriginalFile);
    this.onImageUpdate(this.originalFile);
  }

  get cropTitleLabel() {
    return this.$t(`${this.tPrefix}.cropTitleDefault`);
  }

  async enterEditMode() {
    const {
      initialCropState,
      boundaryOptions,
      viewportOptions,
      saveEditMode,
      onCancelEditMode,
      imageId,
      options,
      cropTitleLabel
    } = this;

    const src = this.originalFile
      ? this.originalFile
      : await getBase64FromUrl(this.value.imageUrl);

    this.originalFile = src;

    eventBus.$emit(
      'openSubModal',
      new ModalOptions(
        ``,
        ``,
        'none',
        true,
        ``,
        ``,
        ``,
        false,
        'cropModal',
        false,
        true,
        true,
        false,
        true,
        null,
        false
      ),
      {
        initialState: initialCropState,
        onSave: saveEditMode,
        onCancel: onCancelEditMode,
        boundaryOptions,
        viewportOptions,
        options,
        minZoom: String(this.cropMinZoom),
        scaleImage: true,
        scaleCanvas: !isIos(),
        disableBackground: true,
        src,
        title: cropTitleLabel,
        actualImage: null,
        imageId,
        roundedCropWrapper: true,
        returnTo: null,
        maxZoom: 0.99,
        initialZoom: 0,
        brandedCoinShape: this.brandedCoinShape,
        brandedCoinColor: this.brandedCoinColor
      }
    );
  }
}
